import React, { useEffect, useRef, useState } from 'react';

// Also the list share link in components/share/shareSubjects.js.
export const shortLink = (code) => `https://prozp.co/r/${code}`;
const pdfLink = (code) => `${window.location.origin}/api/reports/public/${code}/pdf?orientation=landscape`;

export default function ListHeader({
  list, canEdit, sports, ownerName, autoFocusTitle, onRename, onChangeSport, onShare, onDelete, onCopyToMine,
}) {
  const [draft, setDraft] = useState(list.title);
  const [menu, setMenu] = useState(false);
  const [copied, setCopied] = useState(false);
  const titleRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => { setDraft(list.title); }, [list.id, list.title]);
  useEffect(() => {
    if (autoFocusTitle && titleRef.current) { titleRef.current.focus(); titleRef.current.select(); }
  }, [autoFocusTitle, list.id]);
  useEffect(() => {
    if (!menu) return undefined;
    const close = (e) => { if (menuRef.current && !menuRef.current.contains(e.target)) setMenu(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [menu]);

  const commit = () => { if (canEdit && draft.trim() && draft.trim() !== list.title) onRename(draft); else setDraft(list.title); };
  const copy = () => {
    if (navigator.clipboard) navigator.clipboard.writeText(shortLink(list.code)).catch(() => {});
    setCopied(true); setTimeout(() => setCopied(false), 1500);
  };
  const sportName = (sports.find((s) => s.slug === list.sport) || {}).name || list.sport;
  const sportEditable = canEdit && list.members.length === 0 && sports.length > 1;

  return (
    <header className="ls-head">
      <div className="ls-head__row1" data-testid="list_head_row1">
        <div className="ls-head__main">
          <div className="ls-head__meta">
            {sportEditable ? (
              <select className="ls-chip ls-chip--select" value={list.sport} data-testid="list_sport"
                aria-label="Sport" onChange={(e) => onChangeSport(e.target.value)}>
                {sports.map((s) => <option key={s.slug} value={s.slug}>{s.name}</option>)}
              </select>
            ) : <span className="ls-chip">{sportName}</span>}
            {canEdit
              ? <span className="ls-head__hint">Created by you · Saved automatically</span>
              : <span className="ls-head__hint" data-testid="list_readonly">{`Shared by ${ownerName || 'ProZpects Staff'} · view only`}</span>}
          </div>
          <input ref={titleRef} className="ls-title" value={draft} readOnly={!canEdit} aria-label="List name"
            data-testid="list_title" onChange={(e) => setDraft(e.target.value)} onBlur={commit}
            onKeyDown={(e) => { if (e.key === 'Enter') e.currentTarget.blur(); if (e.key === 'Escape') { setDraft(list.title); e.currentTarget.blur(); } }} />
        </div>
        <div className="ls-head__actions">
          {canEdit && <button type="button" className="ls-btn ls-btn--dark" onClick={onShare} data-testid="list_share">Share with coaches</button>}
          {!canEdit && onCopyToMine && <button type="button" className="ls-btn ls-btn--dark" onClick={onCopyToMine} data-testid="list_copy_mine">Copy to my lists</button>}
          {canEdit && (
            <span className="ls-menu-wrap" ref={menuRef}>
              <button type="button" className="ls-btn ls-btn--round" aria-label="More" aria-haspopup="menu" aria-expanded={menu}
                onClick={() => setMenu((v) => !v)} data-testid="list_menu">⋯</button>
              {menu && (
                <div className="ls-menu" role="menu">
                  <button type="button" role="menuitem" className="ls-menu__item ls-menu__item--danger"
                    onClick={() => { setMenu(false); onDelete(); }} data-testid="list_menu_delete">Delete list</button>
                </div>
              )}
            </span>
          )}
        </div>
      </div>
      <div className="ls-head__row2" data-testid="list_head_row2">
        <span className="ls-link-pill">
          <code className="ls-link-pill__code">{`prozp.co/r/${list.code}`}</code>
          <button type="button" className="ls-btn ls-btn--tiny" onClick={copy} data-testid="list_copy">{copied ? 'Copied' : 'Copy'}</button>
        </span>
        <a className="ls-btn ls-btn--tiny" href={pdfLink(list.code)} target="_blank" rel="noreferrer" data-testid="list_pdf">PDF</a>
      </div>
    </header>
  );
}
